import React, { useState } from "react";
import CartBannerComponent from "../../Components/ProdectBanner/CartBannerComponent";
import "./index.css";

const Brands = () => {
  const [search, setSearch] = useState("");

  const brandList = [
    { id: 1, name: "Aarong", category: "Fashion & Lifestyle", description: "Aarong is Bangladesh's leading fashion and lifestyle brand, supporting over 65,000 artisans. It represents the finest hand-woven fabrics and traditional craftsmanship.", logoText: "A", tag: "Handicrafts" },
    { id: 2, name: "PRAN", category: "Food & Beverage", description: "PRAN is Bangladesh's largest food and beverage brand, exporting authentic Bangladeshi flavors to over 140 countries.", logoText: "P", tag: "Exports" },
    { id: 3, name: "Walton", category: "Electronics", description: "Walton is a pioneer in manufacturing high-tech electronics, home appliances, and smart devices in Bangladesh.", logoText: "W", tag: "High Tech" },
    { id: 4, name: "Beximco", category: "Textiles & Pharma", description: "Beximco Group is one of the largest conglomerates in Bangladesh, manufacturing world-class pharmaceuticals and textiles.", logoText: "B", tag: "Premium" },
    { id: 5, name: "Apex", category: "Footwear", description: "Apex Footwear is a pioneer in leather product manufacturing and shoe retail in Bangladesh.", logoText: "Ap", tag: "Leather" },
    { id: 6, name: "Grameen Check", category: "Handloom Fabrics", description: "Grameen Check promotes handloom fabrics produced by local weavers in rural Bangladesh.", logoText: "G", tag: "Weaves" },
    { id: 7, name: "Monno Ceramic", category: "Tableware", description: "Monno Ceramic manufactures top-tier bone china and porcelain tableware exported to leading global retail brands.", logoText: "M", tag: "Ceramics" },
    { id: 8, name: "Kazi & Kazi Tea", category: "Beverages", description: "The first internationally certified organic tea garden in Bangladesh, producing premium organic teas.", logoText: "K", tag: "Organic" },
  ];

  const filteredBrands = brandList.filter(brand =>
    brand.name.toLowerCase().includes(search.toLowerCase()) ||
    brand.category.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div>
      <CartBannerComponent title="Our Brands" />
      <div className="container brands-container my-5">
        <div className="row mb-4">
          <div className="col-md-8 mx-auto text-center">
            <h2 className="brands-title mb-3">Authentic Bangladeshi Brands</h2>
            <p className="brands-subtitle text-muted">
              We partner with Bangladesh's most trusted and iconic brands to deliver exceptional products that celebrate local heritage and quality craftsmanship.
            </p>
            <div className="search-box-wrapper mt-4">
              <input
                type="text"
                placeholder="Search brands or categories..."
                className="form-control brand-search-input"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
              <span className="search-icon"><i className="fa fa-search" /></span>
            </div>
          </div>
        </div>

        <div className="row">
          {filteredBrands.length > 0 ? (
            filteredBrands.map(brand => (
              <div key={brand.id} className="col-lg-3 col-md-6 mb-4">
                <div className="brand-card shadow-sm h-100">
                  <div className="brand-card-top d-flex align-items-center justify-content-center">
                    <div className="brand-logo-circle">{brand.logoText}</div>
                    <span className="brand-badge">{brand.tag}</span>
                  </div>
                  <div className="brand-card-body p-4">
                    <h5 className="brand-name font-weight-bold">{brand.name}</h5>
                    <span className="brand-category mb-3 d-inline-block text-primary">{brand.category}</span>
                    <p className="brand-desc text-muted">{brand.description}</p>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="col-12 text-center py-5">
              <i className="fa fa-search-plus fa-3x text-muted mb-3" />
              <h4>No Brands Found</h4>
              <p className="text-muted">Try searching with a different keyword.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Brands;